module.exports = __webpack_public_path__ + "static/odg-pix-2-657bdf5ca50225065db22a5a66ed5dd7.svg";